<template>
  <v-row justify="center" align="center">
    <v-col cols="12" align="center">
      <v-card>
        <v-card-title>
          Active Visitors
          <v-spacer></v-spacer>
          <v-text-field
            v-model="activeSearch"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="activeGuests" :search="activeSearch"></v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { guestsRef } from "../firebaseApp";

export default {
  data: () => ({
    menu: false,
    modal: false,
    menu2: false,
    guest: {
      unit: "",
      licensePlate: "",
      model: "",
      color: "",
      dateAdded: "",
      expirationDate: ""
    },
    guests: [],
    activeGuests: [],
    alert: {
      type: "",
      message: ""
    },
    requiredRules: [v => !!v || "Required"],
    search: "",
    activeSearch: "",
    headers: [
      {
        text: "Unit",
        align: "left",
        sortable: false,
        value: "unit"
      },
      { text: "License Plate", value: "licensePlate" },
      { text: "Model", value: "model" },
      { text: "Color", value: "color" },
      { text: "Date", value: "dateAdded" },
      { text: "Expires on ", value: "expirationDate" }
    ]
  }),
  methods: {
    isOver24Hours(date) {
      let oneDay = new Date(new Date(date).getTime() + 1 * 24 * 60 * 60 * 1000),
        today = new Date();
      if (oneDay >= today) {
        return false;
      } else if (oneDay < today) {
        return true;
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    loadGuests() {
      let guests = [];
      this.guests = [];
      guestsRef.on("value", snap => {
        snap.forEach(guest => {
          let mem = {};
          mem = guest.val();
          mem.id = guest.key;
          mem.dateAdded =
            guest.val().dateAdded == undefined
              ? ""
              : new Date(guest.val().dateAdded).toLocaleDateString();
          mem.expirationDate =
            guest.val().expirationDate == undefined
              ? ""
              : new Date(guest.val().expirationDate).toLocaleDateString();
          guests.push(mem);
        });
        if (guests.length) {
          this.guests = guests;
          this.loadActiveGuests();
        }
      });
    },
    loadActiveGuests() {
      let uniqueVisitors = [];
      let visitors = this.guests;
      uniqueVisitors = Array.from(
        new Set(visitors.map(a => a.licensePlate))
      ).map(licensePlate => {
        return visitors.find(a => a.licensePlate === licensePlate);
      });
      let activeVisitors = [];
      uniqueVisitors.forEach(visitor => {
        if (
          visitor.expirationDate != undefined &&
          visitor.expirationDate != ""
        ) {
          let today = new Date();
          if (Date.parse(today) < Date.parse(visitor.expirationDate)) {
            activeVisitors.push(visitor);
          }
        } else if (!this.isOver24Hours(visitor.dateAdded)) {
          activeVisitors.push(visitor);
        }
      });
      this.activeGuests = activeVisitors;
    }
  },
  mounted() {
    this.loadGuests();
  }
};
</script>